import React, {memo, useEffect} from "react";
import { Link, withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Icon from 'components/Icon';

import covidBanner from 'assets/images/banner-covid19.png';
// import proposalFile from 'assets/files/nahartime-proposal.pdf';
import MainMenu from './MainMenu';
import UserMenu from './UserMenu';
import Credit from './Credit';

import {
	Wrapper,
	Logo,
	Left,
	Right,
	Username,
	BackButton,
	HeaderContainer,
	CovidBanner,
} from './style';

const Header = ({ location }) => {
	const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
	const profile = useSelector((state) => state.user.profile);


	useEffect(()=>{
		if (isLoggedIn && profile && "$gapify" in window){
			window.$gapify.setUser(profile.username, {
				name: profile.firstName + " " + profile.lastName,
				phone_number: profile.mobile,
			})
		}
	} , [profile , isLoggedIn])


	const isHome = location.pathname === '/';
	const isRegister = location.pathname === '/register';
	const isLoginPage = location.pathname.indexOf('/signin') !== -1;
	const isOrderPage = location.pathname.indexOf('/menu') !== -1;

	return !isLoginPage ? (
		<HeaderContainer>
			{/* {(isHome || isRegister) && (
				<a
					href={`${proposalFile}?utm_source=Nahartime&utm_medium=Covid-19 Banner&utm_campaign=Proposal`}
					target='_blank'
					rel='noopener noreferrer'
				>
					<CovidBanner img={covidBanner} />
				</a>
			)} */}
			{!isRegister && (
				<Wrapper isHome={isHome} isOrderPage={isOrderPage}>
					<Left>
						{isHome ? (
							<MainMenu />
						) : (
							<>
								{isLoggedIn && (
									<>
										{isOrderPage ? (
											<Credit />
										) : (
											<BackButton as={Link} to='/menu'>
												<Icon name='angle-left' />
												بازگشت
											</BackButton>
										)}
									</>
								)}
							</>
						)}
					</Left>

					<Logo $isHome={isHome}>
						<Link to={isHome ? '/' : '/menu'} />
					</Logo>

					{isLoggedIn && !isHome && (
						<Right>
							<UserMenu profile={profile} location={location} />

							<Username>
								{profile.firstName} {profile.lastName}
							</Username>
							{/* {isOrderPage && <Credit />} */}
						</Right>
					)}
				</Wrapper>
			)}
		</HeaderContainer>
	) : null;
};

const areEqual = (prev, next) => {
	if (next.location.state && next.location.state.background) return true;
	if (prev.location === next.location) return true;
	return false;
};
export default withRouter(memo(Header, areEqual));
